import React, { useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import metadata from './MLClaimReservesComponent.metadata.json5';

import styles from '../MLClaimDetailPopup/MLClaimDetailPopup.module.scss';
import { IntlContext } from '@jutro/legacy/locale';

const MLClaimReservesComponent = (props) => {
    const {
        reserves
    } = props;
    const intl = useContext(IntlContext);

    const formatAmountString = (amount) => {
        const premium = _.get(amount, 'amount', 0);
        const currency = _.get(amount, 'currency', 'usd');

        try {
            return intl.formatNumber(premium, { style: 'currency', currency });
        } catch (e) {
            return '';
        }
    }

    const getReservesOverride = () => {
        const claimReserves = _.isUndefined(reserves) ? [] : reserves.map((reserve, index) => {
            return {
                [`coverageContent${index}`]: {
                    content: reserve.exposure_ML
                },
                [`reserveAmountContent${index}`]: {
                    content: formatAmountString(reserve.reserveAmount_ML)
                },
                [`amountPaidContent${index}`]: {
                    content: formatAmountString(reserve.amountPaid_ML)
                }

            }
        });

        return Object.assign({}, ...claimReserves);
    }

    const overrideProps = {
        reserveIterable: {
            data: reserves
        },
        ...getReservesOverride()
    };
    const resolvers = {
        resolveClassNameMap: styles

    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLClaimReservesComponent.propTypes = {
    reserves: PropTypes.arrayOf(PropTypes.object).isRequired
};


export default MLClaimReservesComponent;
